import { history } from 'Redux/store';
import { currencyCode } from 'Helpers/Geo/data';
import ranges from 'Helpers/Geo/price-ranges';
import { topSellerIndex } from 'Redux/ducks/algolia-calls';

const lgScreenWidth = 992;

const defaultHitsPerPage = window.innerWidth >= lgScreenWidth ? 36 : 18;

export const refinementFilters = {
  types: 'display_type',
  platforms: 'operating_systems',
  drm: 'drm',
  features: 'features',
  vrsupport: 'vr_support',
  steamdecksupport: 'steam_deck_support',
  publishers: 'publishers',
  languages: 'languages',
  collections: 'collections',
  genres: 'genresSlug',
  themes: 'themesSlug',
  playstyles: 'playstylesSlug',
};

const sanitiseParam = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  if (str.includes(',')) {
    return str.split(',').map(sanitiseParam);
  }

  return str;
};

export function searchStateFromUrl(url) {
  const urlParams = Object.fromEntries(new URLSearchParams(url));

  const {
    search,
    price,
    sortBy,
    page,
    onSale,
    hitsPerPage,
  } = urlParams;

  const searchState = {};
  const multiRange = {};
  const refinementList = {};
  const toggle = {};
  const range = {};

  if (search) searchState.query = search;

  if (sortBy && sortBy.includes('price_asc')) {
    range[`price.${currencyCode}`] = { min: 0.01 };
  } else if (price) {
    let refinedPrice = price;

    if (price === ':5') {
      if (currencyCode === 'JPY' || currencyCode === 'RUB') {
        refinedPrice = ':500';
      }
      if (currencyCode === 'CAD' || currencyCode === 'AUD') {
        refinedPrice = ':8';
      }
    }

    const start = refinedPrice.split(':')[0];
    const end = refinedPrice.split(':')[1];

    const matchedRange = ranges.find(rangeObj => ((
      !start && !rangeObj.start) ||
      Number(start) === rangeObj.start) && ((!end && !rangeObj.end) ||
        Number(end) === rangeObj.end));
    if (matchedRange) {
      multiRange[`price.${currencyCode}`] = refinedPrice;
    }
  }

  Object.keys(refinementFilters).forEach((key) => {
    const attributeName = refinementFilters[key];
    if (urlParams[key]) {
      refinementList[attributeName] = sanitiseParam(urlParams[key]);
    }
  });

  if (sortBy) searchState.sortBy = sanitiseParam(sortBy);
  if (page && page > 1) searchState.page = Number(page);
  if (hitsPerPage) searchState.hitsPerPage = hitsPerPage;
  if (onSale) toggle.on_sale = onSale === 'true';

  if (Object.keys(multiRange).length > 0) searchState.multiRange = multiRange;
  if (Object.keys(refinementList).length > 0) searchState.refinementList = refinementList;
  if (Object.keys(toggle).length > 0) searchState.toggle = toggle;
  if (Object.keys(range).length > 0) searchState.range = range;

  return searchState;
}

export function navigateToSearchState(currentSearchString, searchState, url) {
  const topSellerIndexName = topSellerIndex();

  const {
    refinementList,
    sortBy,
    page,
    toggle,
    hitsPerPage,
    multiRange,
  } = searchState;

  let {
    query,
  } = searchState;

  if (query) {
    query = query.replace(/[^\w\s-]/gi, '');
  }

  const queryObject = {};
  if (query) queryObject.search = query;

  if (sortBy && sortBy !== topSellerIndexName) queryObject.sortBy = sortBy;

  if (page && page > 1) queryObject.page = page;

  if (refinementList) {
    Object.keys(refinementFilters).forEach((key) => {
      const attributeName = refinementFilters[key];
      if (refinementList[attributeName]) {
        queryObject[key] = refinementList[attributeName];
      }
    });
  }

  if (toggle) {
    const { on_sale: onSale } = toggle;
    if (onSale) queryObject.onSale = onSale;
  }

  if (multiRange && (!sortBy || !sortBy.includes('price_asc')) && multiRange[`price.${currencyCode}`]) {
    queryObject.price = multiRange[`price.${currencyCode}`];
  }

  if (hitsPerPage && Number(hitsPerPage) !== defaultHitsPerPage) {
    queryObject.hitsPerPage = hitsPerPage;
  }

  const searchString = new URLSearchParams(queryObject).toString();

  if (searchString !== currentSearchString) {
    const newUrl = `${url}${searchString ? '?' : ''}${searchString}`;
    history.replace(newUrl);
  }

  return false;
}
